export const CHANGE_POPUP_BG_COLOR = 'CHANGE_POPUP_BG_COLOR';
export const CHANGE_POPUP_OVERFLOW = 'CHANGE_POPUP_OVERFLOW';
export const HIDE_POPUP = 'HIDE_POPUP';
export const SET_POPUP = 'SET_POPUP';
export const SHOW_POPUP = 'SHOW_POPUP';
export const SHOW_BG_MAP = 'SHOW_BG_MAP';
export const HIDE_CLOSE_BUTTON = 'HIDE_CLOSE_BUTTON';
